export default "__VITE_ASSET__577873b3__"